// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QMV7Z","type":"styles_type__3FbRb","choices":"styles_choices__1fwF4"};